import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import {
  Overview, PriceList, Highlights, FloorPlanSection,
  AmenitiesSection, Gallery, ScheduleCTA, LocationSection,
  FAQSection, TrustBadges
} from "./components/Sections";
import {
  Footer, StickyMobileCTA, WhatsAppFloat, EnquiryModal,
  OfferBanner, useSmartPopups,
} from "./components/Extras";
import EnquiryForm from "./components/EnquiryForm";
import SiteVisitScheduler from "./components/SiteVisitScheduler";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { SITE } from "./mock";
import { Phone, Mail, MapPin } from "lucide-react";

function Landing() {
  const [modal, setModal] = useState({ open: false, title: "Get Best Offers" });
  const open = (title = "Get Best Offers") => setModal({ open: true, title });
  const close = () => setModal({ ...modal, open: false });

  useSmartPopups(() => open("Limited-Time Pre-Launch Offer"));

  return (
    <div className="App bg-[#fafaf7]">
      <Header onEnquire={() => open("Talk To Our Expert")} />
      <Hero />
      <TrustBadges />
      <Overview onEnquire={() => open("Download Brochure")} />
      <OfferBanner />
      <PriceList onEnquire={() => open("Unlock Price Details")} />
      <Highlights />
      <FloorPlanSection onEnquire={() => open("Request Floor Plan")} />
      <AmenitiesSection />
      <SiteVisitScheduler />
      <Gallery />
      <ScheduleCTA onEnquire={() => open("Book A Site Visit")} />
      <LocationSection />

      {/* Contact section with full form */}
      <section id="contact" className="py-16 md:py-24 bg-[#fafaf7]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 grid md:grid-cols-2 gap-10 items-start">
          <div>
            <div className="uppercase tracking-[0.3em] text-[#C9A24B] text-xs mb-2">Contact</div>
            <h2 className="section-heading text-3xl md:text-4xl mb-3">Get In Touch With Us</h2>
            <span className="gold-divider !mx-0" />
            <p className="text-gray-600 mb-6 leading-relaxed">
              Our expert sales consultants are ready to walk you through pricing, floor plans, payment plans and availability. Reach out today for a complimentary site visit.
            </p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#8B1E1E] text-white flex items-center justify-center shrink-0"><Phone className="w-4 h-4" /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">Call / WhatsApp</div>
                  <a href={`tel:${SITE.phoneRaw}`} className="text-lg font-semibold text-[#8B1E1E] hover:underline">{SITE.phone}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#8B1E1E] text-white flex items-center justify-center shrink-0"><Mail className="w-4 h-4" /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">Email</div>
                  <a href={`mailto:${SITE.email}`} className="text-lg font-semibold text-[#8B1E1E] hover:underline break-all">{SITE.email}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#8B1E1E] text-white flex items-center justify-center shrink-0"><MapPin className="w-4 h-4" /></div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">Sales Lounge</div>
                  <div className="text-lg font-semibold text-gray-800">Magarpatta–Mundhwa, Pune</div>
                </div>
              </li>
            </ul>
          </div>
          <div>
            <EnquiryForm title="Say Hello 👋 — We'd Love to Help" subtitle="Drop your details and our friendly expert will call you back with brochure, price break-up & a site visit slot." source="contact_section" />
          </div>
        </div>
      </section>

      <FAQSection />
      <Footer />

      <StickyMobileCTA onEnquire={() => open("Enquire Now")} />
      <WhatsAppFloat />
      <EnquiryModal open={modal.open} onClose={close} title={modal.title} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
